import React from 'react';
import MainLayout from '../components/layout/MainLayout';

function BaseDonneesPage() {
  return (
    <MainLayout>
      <div style={{ padding: 24 }}>
        <h1>Base de données</h1>
        <p>Page `fhc-base-donnees.html` convertie en composant React.</p>
      </div>
    </MainLayout>
  );
}

export default BaseDonneesPage;
